export default __webpack_public_path__ + "static/media/img-0748-romania-half-face.1ce3bb7f.png";